<template>
  <div v-if="orderGroupItems.data.length" class="space-y-2">
    <div class="flex items-center justify-between">
      <dt class="text-xs text-gray-700">Pengeluaran Grup</dt>
      <BaseInput size="sm" type="text" placeholder="Cari barang" :shadow="false" debounce v-model="filter.search" @native-input="loadOrderGroups" />
    </div>
    <Datatable
      :scroll-x="false"
      :total="orderGroupItems.meta.page.total"
      :perPage="orderGroupItems.meta.page.perPage"
      :currentPage="orderGroupItems.meta.page.currentPage"
      compact
      @pagechanged="onChangePage"
      :columns="
        [
          { id: 'code', name: 'Kode Barang' },
          { id: 'group', name: 'No. Grup' },
          { id: 'name', name: 'Nama Barang' },
          { id: 'qty', name: 'Dikirim', theadClass: 'text-right' },
        ].filter((item) => !!item)
      "
    >
      <template #tbody="{ classes }">
        <tr
          v-for="(orderGroupItem, index) in orderGroupItems.data"
          :key="index"
          :class="classes.tr"
        >
          <td :class="[classes.td]">
            <p class="font-bold text-gray-900">
              {{ orderGroupItem.attributes.product_code }}
            </p>
          </td>
          <td :class="[classes.td]">
            {{ orderGroupItem.attributes.group_code }}
          </td>
          <td :class="[classes.td]">
            {{ orderGroupItem.attributes.product_name }}
          </td>
          <td :class="[classes.td, 'text-right']">
            {{ orderGroupItem.attributes.qty | toCurrency }}
          </td>
        </tr>
      </template>
    </Datatable>
  </div>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  props: {
    orderId: String,
  },
  emits: ['update-loading', 'load'],
  data() {
    return {
      filter: {
        search: null
      },
      loading: false,
      orderGroupItems: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  methods: {
    async loadOrderGroups(params) {
      this.$emit('update-loading', true);

      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}/group-bonuses`,
        {
          params: {
            'page[size]': 5,
            'filter[search]': this.filter.search,
            ...params
          },
        }
      );

      if (!err) {
        this.orderGroupItems = res;
      }

      this.$emit('update-loading', false);
    },
    onChangePage(page) {
      this.loadOrderGroups({
        'page[number]': page
      })
    }
  },
  async created() {
    await this.loadOrderGroups();

    this.$emit('load', { hasItems: this.orderGroupItems.data.length })
  },
};
</script>
